import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./light-theme.css";
import App from "./App";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary";
import { installDatePickerAutoOpen } from "./datePickerAutoOpen";

installDatePickerAutoOpen();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);
